module.exports = __webpack_public_path__ + "img/remove-icon.d17deafb.svg";